import waterSourceApi, {
  ICreateWaterSourcePayload,
} from '@/api/config/waterSourceApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'

async function createWaterSource(
  payload: ICreateWaterSourcePayload,
): Promise<void> {
  await waterSourceApi.create(payload)
}

const useAddWaterSource = () => {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation(
    (payload: ICreateWaterSourcePayload) => createWaterSource(payload),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([queryKeys.waterSource])

        toast.success('Add New Water Source Success')

        closeSidebar()
      },
      onError: (error: any) => {
        toast.error(error?.message)
      },
    },
  )
}

export default useAddWaterSource
